import React from 'react';
import { NexaSubtitle, NexaTitle } from './styled';

const NexaTitleBanner = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 20, marginBottom: 40 }}>
      <NexaTitle>Nexa</NexaTitle>
      <NexaSubtitle>The Next-Generation Analytics</NexaSubtitle>
    </div>
  );
};

export default NexaTitleBanner;
